export const isValidSocialMediaUrl = (url: string): boolean => {
  const regex = /^(?:https?:\/\/)?(?:www\.)?(?:facebook|instagram|twitter|x)\.com\/.*$/i;

  return regex.test(url);
};
